import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CountryRow from './CountryRow';
import { countriesType, sortingParamType } from '../../types';
import './_styles_/CountriesList.css';
import SortControl from '../SortControl';

CountriesList.propTypes = {
    countries: countriesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function CountriesList(props) {
    const {
        countries,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="countries-list">
            <div className="rich-list-row rich-list-header countries-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="country-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('countries.list-header.name')}
                    </SortControl>
                </div>
                <div className="country-header--values--code">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="code">
                        {t('countries.list-header.code')}
                    </SortControl>
                </div>
                <div className="country-header--values--active">
                    <SortControl sortingKey="active" sortingParam={sortingParam} onChange={onSort}>
                        {t('countries.list-header.active')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                countries.length
                    ? countries.map((country) => <CountryRow country={country} key={country.id} />)
                    : (<div className="countries-no-items">{t('countries.no-items')}</div>)
            }
        </div>
    );
}

export default CountriesList;
